/**
 * ドラクエ9 宝の地図フロアマップの領域の情報を保持するクラス
 * @class Area
 */
class Area {
  /**
   * @type {number} 領域の左端のx座標
   */
  private _left: number = 0

  /**
   * @type {number} 領域の上端のy座標
   */
  private _top: number = 0

  /**
   * @type {number} 領域の右端のx座標
   */
  private _right: number = 0

  /**
   * @type {number} 領域の下端のy座標
   */
  private _bottom: number = 0

  /**
   * @type {boolean} 領域が上下に分割されたかどうか
   */
  private _isDividedTopAndBottom: boolean = false

  /**
   * @type {boolean} 領域が左右に分割されたかどうか
   */
  private _isDividedLeftAndRight: boolean = false

  /**
   * @type {number} 部屋の要素番号
   */
  private _roomIndex: number = 0

  /**
   * 領域の左端のx座標のgetter
   * @returns {number} 領域の左端のx座標
   */
  public get left(): number {
    return this._left
  }

  /**
   * 領域の左端のx座標のsetter
   * @param {number} value 領域の左端のx座標
   */
  public set left(value: number) {
    this._left = value
  }

  /**
   * 領域の上端のy座標のgetter
   * @returns {number} 領域の上端のy座標
   */
  public get top(): number {
    return this._top
  }

  /**
   * 領域の上端のy座標のsetter
   * @param {number} value 領域の上端のy座標
   */
  public set top(value: number) {
    this._top = value
  }

  /**
   * 領域の右端のx座標のgetter
   * @returns {number} 領域の右端のx座標
   */
  public get right(): number {
    return this._right
  }

  /**
   * 領域の右端のx座標のsetter
   * @param {number} value 領域の右端のx座標
   */
  public set right(value: number) {
    this._right = value
  }

  /**
   * 領域の下端のy座標のgetter
   * @returns {number} 領域の下端のy座標
   */
  public get bottom(): number {
    return this._bottom
  }

  /**
   * 領域の下端のy座標のsetter
   * @param {number} value 領域の下端のy座標
   */
  public set bottom(value: number) {
    this._bottom = value
  }

  /**
   * 領域が上下に分割されたかどうかのgetter
   * @returns {boolean} 領域が上下に分割されたかどうか
   */
  public get isDividedTopAndBottom(): boolean {
    return this._isDividedTopAndBottom
  }

  /**
   * 領域が上下に分割されたかどうかのsetter
   * @param {boolean} value 領域が上下に分割されたかどうか
   */
  public set isDividedTopAndBottom(value: boolean) {
    this._isDividedTopAndBottom = value
  }

  /**
   * 領域が左右に分割されたかどうかのgetter
   * @returns {boolean} 領域が左右に分割されたかどうか
   */
  public get isDividedLeftAndRight(): boolean {
    return this._isDividedLeftAndRight
  }

  /**
   * 領域が左右に分割されたかどうかのsetter
   * @param {boolean} value 領域が左右に分割されたかどうか
   */
  public set isDividedLeftAndRight(value: boolean) {
    this._isDividedLeftAndRight = value
  }

  /**
   * 部屋の要素番号のgetter
   * @returns {number} 部屋の要素番号
   */
  public get roomIndex(): number {
    return this._roomIndex
  }

  /**
   * 部屋の要素番号のsetter
   * @param {number} value 部屋の要素番号
   */
  public set roomIndex(value: number) {
    this._roomIndex = value
  }

  /**
   * 領域の4辺の座標を一括で指定する
   * @param {number} left 領域の左端のx座標
   * @param {number} top 領域の上端のy座標
   * @param {number} right 領域の右端のx座標
   * @param {number} bottom 領域の下端のy座標
   */
  public setCoordinate(left: number, top: number, right: number, bottom: number): void {
    this._left = left
    this._top = top
    this._right = right
    this._bottom = bottom
  }
}

export { Area }
